module.exports = __webpack_public_path__ + "static/media/mpeg5_lcevc_logo.2848771c.png";